// extracted by mini-css-extract-plugin
module.exports = {"category-page":"CategoryPage_category-page__3n4Gs","category-page__description":"CategoryPage_category-page__description__9w-RK"};